import { gql } from '@apollo/client';

export const GET_PROJECT_MEMBERS = gql`
  query ProjectMembers($id: ID!) {
    project(id: $id) {
      id
      createdBy {
        id
      }
      members {
        id
        profile {
          firstName
          lastName
        }
      }
    }
  }
`;

export const ADD_PROJECT_MEMBER = gql`
  mutation AddProjectMember($projectId: ID!, $userId: ID!) {
    addProjectMember(projectId: $projectId, userId: $userId) {
      project {
        id
        members {
          id
        }
      }
    }
  }
`;

export const REMOVE_PROJECT_MEMBER = gql`
  mutation RemoveProjectMember($projectId: ID!, $userId: ID!) {
    removeProjectMember(projectId: $projectId, userId: $userId) {
      project {
        id
        members {
          id
        }
      }
    }
  }
`;

export const GET_COMPANY_MEMBERS = gql`
  query CompanyMembers($companyId: ID!) {
    companyMembers(companyId: $companyId, hidden: false) {
      id
      projectApproval
      user{
        id
        email
        profile {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
